import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import {
  type WorkspaceProvisioningTaskStatus,
  WORKSPACE_PROVISIONING_TASK_STATUS_COLOUR_MAP,
} from '@principle-theorem/principle-core/interfaces';
import { StatusLabelComponent } from '../status-label/status-label.component';

@Component({
  selector: 'pr-workspace-provisioning-task-status',
  templateUrl: './workspace-provisioning-task-status.component.html',
  styleUrls: ['./workspace-provisioning-task-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StatusLabelComponent],
})
export class WorkspaceProvisioningTaskStatusComponent {
  dense = input(false, {
    transform: coerceBooleanProperty,
  });
  status = input.required<WorkspaceProvisioningTaskStatus>();
  statusColor = computed(
    () => WORKSPACE_PROVISIONING_TASK_STATUS_COLOUR_MAP[this.status()]
  );
}
